import type { Session } from "@supabase/supabase-js";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface AuthStoreState {
  session: Session | null;
  impersonateId: string | null;
  setImpersonateId: (impersonateId: string | null) => void;
  setSession: (session: Session | null) => void;
  sessionChecked: boolean;
  setSessionChecked: (sessionChecked: boolean) => void;
}

export const useAuthStore = create<AuthStoreState>()(
  devtools((set) => ({
    session: null,
    setSession: (session) => set({ session }),
    sessionChecked: false,
    setSessionChecked: (sessionChecked) => set({ sessionChecked }),
    impersonateId: null,
    setImpersonateId: (impersonateId) => set({ impersonateId }),
  })),
);
